export default "__VITE_ASSET__D02o_Qx1__"